import { Injectable } from '@angular/core';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';

@Injectable({
	providedIn: 'root'
})
export class PreciousFinishService {

	public removeDuplicates(data: ComponentVariantFromApiModel[]) {
		const allThatDontHaveSemi = [...new Set(data.filter(item => !item.Code.includes(';')).map((item) => item))];

		const allThatHaveSemi = [...new Set(data.filter(item => item.Code.includes(';')).map(item => item))];

		let distinct: Map<string, ComponentVariantFromApiModel> = new Map<string, ComponentVariantFromApiModel>();

		allThatHaveSemi.forEach(item => {
			let x = item.Code.substring(0, item.Code.lastIndexOf(';'));

			if (!distinct.has(x)) {
				item.Code = x;
				distinct.set(x, item);
			}
		});

		const distinctList = [...allThatDontHaveSemi, ...distinct.values()];

		return distinctList;
	}

}
